import React from "react";
import { experience } from "./resumeData";

function ResumeExperience() {
  return (
    <div className="resume-list">
      {experience.map((job) => {
        const isCurrent = job.period.toLowerCase().includes("present");
        return (
          <div className="resume-card" key={job.company + job.period}>
            <div className="resume-card-top-row">
              <h3 className="resume-card-title">{job.role}</h3>
              <span className="resume-card-period">
                {job.period}
                <span className={`resume-dot ${isCurrent ? "resume-dot-active" : "resume-dot-muted"}`} />
              </span>
            </div>
            <p className="resume-card-subtitle">{job.company}</p>
            <ul className="resume-card-highlights">
              {job.highlights.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <div className="resume-chip-row">
              {job.tech.map((tech) => (
                <span className="resume-chip" key={tech}>
                  {tech}
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ResumeExperience;
